import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router, CanActivate } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { TokenValidationService } from '../Services/token-validation.service';
import { TokenEncryptionService } from '../Services/token-encryption.service';
import { clearStoragePreservingAttribution } from './attribution.util';

@Injectable({
  providedIn: 'root'
})
export class checkTokenGuard implements CanActivate {
  constructor(
    private router: Router,
    private tokenValidation: TokenValidationService,
    private tokenEncryption: TokenEncryptionService
  ) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const token = this.tokenEncryption.getToken();
    const isLoggedIn = localStorage.getItem('isLogedIn') === 'true';

    // If no token or not logged in, allow access to auth pages
    if (!token || !isLoggedIn) {
      return true;
    }

    // If token is expired, clear session and allow access to auth pages
    if (this.tokenValidation.isTokenExpired(token)) {
      this.clearSession();
      return true;
    }

    // Validate token with backend
    return this.tokenValidation.validateToken(token).pipe(
      map(valid => {
        if (valid) {
          // Token is valid and user is logged in - redirect away from auth pages
          this.router.navigate(['/']);
          return false;
        } else {
          this.clearSession();
          return true;
        }
      }),
      catchError(() => {
        this.clearSession();
        return of(true);
      })
    );
  }

  private clearSession(): void {
    clearStoragePreservingAttribution(localStorage);
    sessionStorage.clear();
  }
}
